import React from "react";
import { useParams } from "react-router-dom";
import AdminMemberDetail from "./AdminMemberDetail";
import MemberPurchasesPanel from "./MemberPurchasesPanel";

export default function AdminMemberDetailWithPurchases() {
  const { id } = useParams();

  return (
    <>
      <AdminMemberDetail />
      <MemberPurchasesPanel memberId={id} />
    </>
  );
}
